<script setup>
import { ref } from 'vue';

import T from './CompanyFollowButton.i18n.js';

import { checkLogin, LoginResult } from 'JIX/utils/login.js';
import { followCompany, unfollowCompany } from 'JIX/mycompany/api.js';

const props = defineProps({
    companyid: {
        type: Number,
        required: true,
    },
    following: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['update']);

const pending = ref(false);

async function toggle() {
    if (!props.following) {
        const res = await followCompany({ id: props.companyid });
        return { following: !!res.mycompany };
    } else {
        await unfollowCompany({ id: props.companyid });
        return { following: false };
    }
}

async function handleClick() {
    pending.value = true;
    try {
        const loginResult = await checkLogin();
        if (loginResult !== LoginResult.ABORTED) {
            const res = await toggle();
            emit('update', res);
        }
    } finally {
        pending.value = false;
    }
}
</script>

<template>
    <button
        class="jix-follow-company"
        :class="{'jix-follow-company-pending': pending, 'jix-follow-company-active': following}"
        @click="handleClick"
    >
        {{ following ? T.following() : T.follow() }}
    </button>
</template>
